export default {
	name: 'Comments',
	data() {
		return {
			replyForm: false,
		}
	},
	methods: {
		openReplyForm(id) {
			event.preventDefault();
			this.replyForm = id;
		},
		closeReplyForm() {
			this.replyForm = false;
		}
	}
}
